export default "__VITE_ASSET__b68a0c19__"